import { render } from "./ReceivedPacketMetricsDownloader.vue?vue&type=template&id=ebb564e8&scoped=true&ts=true"
import script from "./ReceivedPacketMetricsDownloader.vue?vue&type=script&lang=ts"
export * from "./ReceivedPacketMetricsDownloader.vue?vue&type=script&lang=ts"

import "./ReceivedPacketMetricsDownloader.vue?vue&type=style&index=0&id=ebb564e8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb564e8"]])

export default __exports__